import { gql, TypedDocumentNode } from "@apollo/client";

import {
  RequestPhoneVerificationMutation,
  RequestPhoneVerificationMutationVariables,
  UpdateVerifiedPhoneSharingMutation,
  UpdateVerifiedPhoneSharingMutationVariables,
  DeleteVerifiedPhoneMutation,
  DeleteVerifiedPhoneMutationVariables,
} from "./PhoneVerification.generated";

export const REQUEST_PHONE_VERIFICATION: TypedDocumentNode<
  RequestPhoneVerificationMutation,
  RequestPhoneVerificationMutationVariables
> = gql`
  mutation RequestPhoneVerification(
    $phoneNumber: String!
    $teamUuid: String
    $extension: [ExtensionStepInput]
  ) {
    requestPhoneVerification(
      phoneNumber: $phoneNumber
      teamUuid: $teamUuid
      extension: $extension
    ) {
      success
      message
      validationCode
      verifiedPhoneUuid
    }
  }
`;

export const UPDATE_VERIFIED_PHONE_SHARING: TypedDocumentNode<
  UpdateVerifiedPhoneSharingMutation,
  UpdateVerifiedPhoneSharingMutationVariables
> = gql`
  mutation UpdateVerifiedPhoneSharing(
    $verifiedPhoneUuid: String!
    $teamUuid: String
  ) {
    updateVerifiedPhoneNumberSharing(
      verifiedPhoneUuid: $verifiedPhoneUuid
      teamUuid: $teamUuid
    ) {
      success
      message
    }
  }
`;

export const DELETE_VERIFIED_PHONE: TypedDocumentNode<
  DeleteVerifiedPhoneMutation,
  DeleteVerifiedPhoneMutationVariables
> = gql`
  mutation DeleteVerifiedPhone($verifiedPhoneUuid: String!) {
    deleteVerifiedPhoneNumber(verifiedPhoneUuid: $verifiedPhoneUuid) {
      success
      message
    }
  }
`;
